// ShipmentDocuments.tsx
import React, { useEffect, useState } from "react";
import {
  Card,
  CardContent,
  CardActions,
  CardMedia,
  Typography,
  Button,
  Grid2 as Grid,
  Box,
  Paper,
} from "@mui/material";
import exportDocumentService from "../services/exportDocumentService"; // adjust path
import { settings } from "../apiSettings";
import dayjs from "dayjs";
import {downloadFile} from "../util/globals"

type ShipmentDocument = {
  id: number | string;
  shipping_no: string;
  stored_path: string;
  file_extension: string;
  descr?: string;
};

type Props = {
  shipNo: string;
  closeDialog: (val: boolean) => void;
};

function getFileType(ext: string): "image" | "pdf" | "excel" | "other" {
  const e = ext.toLowerCase();

  if (["jpg", "jpeg", "png", "gif", "webp", "bmp"].includes(e)) return "image";
  if (e === "pdf") return "pdf";
  if (["xls", "xlsx", "csv", "xlsm"].includes(e)) return "excel";

  return "other";
}

export default function ShipmentDocuments({ shipNo,closeDialog }: Props) {
  const [list, setList] = useState<ShipmentDocument[]>([]);
  const [loading, setLoading] = useState(true);
 
  const getDocuments = async () => {
    try {
      setLoading(true);
      const response = await exportDocumentService.getDocumentsByShippingNo(shipNo);
      setList(response.data);
     
    } catch (error) {
      console.error("Error fetching documents:", error);
      closeDialog(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    console.log("Fetching documents for shipping no:", shipNo);
    getDocuments();
  }, [shipNo]);

  if (loading) return <Typography>Loading documents…</Typography>;
  //if (list.length === 0) return <Typography>No documents found.</Typography>;

  return (
    <Paper sx={{ p: 2, maxHeight: 595, maxWidth: 700, overflowY: "auto" }}>
        <Typography variant="body1" gutterBottom sx={{
            bgcolor: 'primary.main',
            color: 'primary.contrastText',
            p: 1,
            mb: 2,
            textAlign: 'center',
            borderRadius: 1
        }}>
        Export Documents for Shipment: {shipNo}
        </Typography>
    <Box sx={{width:550}}  display={"flex"} gap={2} flexWrap={"wrap"} >
      {list.map((doc) => {
        const fileType = getFileType(doc.file_extension);

        // Ensure path starts with /
        const fileUrl = doc.stored_path.startsWith("/")
          ? doc.stored_path
          : "/" + doc.stored_path;

          
        return (
          <Box key={doc.id} display={"flex"} justifyContent={"center"} alignItems={"center"} flexDirection={"column"}>      
            <Card sx={{ width: 170,height:230  }}>
              
              {/* File preview */}
              {fileType === "image" ? (
                <Box height="70%" width="100%">
                <Box
                  component="img"
                  height="100%"
                  width="100%"
                  src={ settings.baseURL + fileUrl}
                  alt={doc.shipping_no}
                  sx={{
                    objectFit: "cover",
                    borderBottom: 1,
                    borderColor: "divider",
                    m: 0,
                    p: 0,
                  }}
                />
                </Box>
              ) : (
                <Box 
                  sx={{
                   height: "70%",
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    bgcolor: "action.hover",
                    borderBottom: 1,
                    borderColor: "divider",
                    fontSize: 24,
                    fontWeight: 700,
                   
                  }}
                >
                  {fileType === "pdf" && "PDF"}
                  {fileType === "excel" && "EXCEL"}
                  {fileType === "other" && doc.file_extension.toUpperCase()}
                </Box>
                
              )}
                <Typography variant="body1" sx={{fontSize: 12,px:1}}>{doc.descr}</Typography>
                
              <Box sx={{ display:"flex",justifyContent: "end" ,marginTop:1,p:1}}>
                <Button  size="small"
                sx={{ textTransform: "none" }}
                onClick={()=> { 
                    downloadFile(`${settings.baseURL}${fileUrl}`, `${doc.shipping_no}_${dayjs().format('YYYYMMDD')}.${doc.file_extension}`);
                }}>
                    Download
                </Button>
               
              </Box>
            </Card>
          </Box>
          
        );
        
      })}
    </Box>
    <Typography variant="body1" textAlign={"center"} sx={{fontSize: 16,px:1}}>{list.length==0 ? "No document uploaded" :""}</Typography>
    <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 1 }}>
     <Button 
    
     size="small"
     variant="contained"
     color="primary"
     onClick={()=>closeDialog(false)}>Close</Button>
     </Box>
    </Paper>
  );
}
